import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Container, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { applyCSS } from '../../utils/helper';

import Header from '../../components/_Header';
import Breadcrumb from '../../components/_Breadcrumb';

import MyTrainings from '../../views/_MyTrainings/List';
import TrainingResults from '../../views/_MyTrainings/Results';
import StartConfirmation from '../../views/_MyTrainings/start';
import EndConfirmation from '../../views/_MyTrainings/end';
import Lessons from '../../views/_Lessons';
import LessonDetails from '../../views/_Lessons/Details';
import LessonResults from '../../views/_Lessons/Results';
import Contents from '../../views/_Lessons/Contents';
import ContentsTraining from '../../views/_MyTrainings/Contents';
import Profile from '../../views/_Profile';
import ChangePassword from '../../views/_Profile/ChangePassword';

// Passing
import NextQuestion from '../../views/_Lessons/Passing';

import Filters from '../../views/_Filters/Filters';
import Dashboard from '../../views/Dashboard/Dashboard';

import Colors from '../../views/Theme/Colors/Colors';
import Typography from '../../views/Theme/Typography/Typography';

import Charts from '../../views/Charts/Charts';
import Widgets from '../../views/Widgets/Widgets';

// Info
import InfoTerms from '../../views/_InfoServices/Terms';
import InfoService from '../../views/_InfoServices/Info';
import InfoFaq from '../../views/_InfoServices/Faq';

// Chats
import Chats from '../../views/_Chats';
import ChatDetails from '../../views/_Chats/Messages';
import SupportChat from '../../views/_Chats/Support';

// Certificates
import Certificates from '../../views/_Certificates';

// Notes
import TrainingNotes from '../../views/_Lessons/Notes/Training';
import LessonNotes from '../../views/_Lessons/Notes/Lesson';

// Pictures
import AllPictures from '../../views/_Lessons/Pictures/All';
import AllNotes from '../../views/_Lessons/Notes/All';
import TrainingPictures from '../../views/_Lessons/Pictures/Training';
import LessonPictures from '../../views/_Lessons/Pictures/Lesson';

import { hideModal, removeModal } from '../../actions/modals';

const mapStateToProps = ({ modals, user }) => ({
  modal: modals.list[0],
  user,
});
const mapDispatchToProps = dispatch => bindActionCreators({
  hideModal,
  removeModal,
}, dispatch);

class Full extends React.Component {
  componentDidMount() {
    applyCSS();
  }

  render() {
    const { user, modal } = this.props;
    if (!user.token) {
      return <Redirect to="/login" />;
    }

    return (
      <div className="app">{modal && (
        <Modal
          isOpen={modal.show}
          toggle={this.props.hideModal}
          className={`modal-${modal.level} modal-lg`}
          onClosed={this.props.removeModal}
        >
          {modal.title && <ModalHeader>{modal.title}</ModalHeader>}
          <ModalBody className="align-items-center">
            {modal.text && <div dangerouslySetInnerHTML={{ __html: modal.text }} />}
            {modal.messages.map(message => (
              <div key={message}><FormattedMessage id={message} /></div>))}
          </ModalBody>
          <ModalFooter>{modal.download && (
            <a href={modal.download} rel="noopener noreferrer" target={user && user.options.all_in_one_tab ? "_self" : "_blank"} onClick={this.props.hideModal}>
              <Button color={modal.level}><FormattedMessage id="overall_input_download" /></Button>
            </a>)}
            <Button color={modal.level} onClick={this.props.hideModal}><FormattedMessage id="overall_input_ok" /></Button>
          </ModalFooter>
        </Modal>)}
        <Header />
        <div className="app-body">
          <main className="main">
            <Breadcrumb />
            <Container>
              <Switch>
                <Route exact path="/trainings/mytrainings/:tid/lessons/:id/passing" name="Next Question" component={NextQuestion} />
                <Route exact path="/trainings/mytrainings/:tid/lessons/:id/results" name="Results" component={LessonResults} />
                <Route exact path="/trainings/mytrainings/:tid/lessons/:id/contents/text" name="Contents" component={Contents} />
                <Route exact path="/trainings/mytrainings/:tid/lessons/:id/contents/link" name="Contents" component={Contents} />
                <Route exact path="/trainings/mytrainings/:tid/lessons/:id/contents/audio" name="Contents" component={Contents} />
                <Route exact path="/trainings/mytrainings/:tid/lessons/:id/contents/video" name="Contents" component={Contents} />
                <Route exact path="/trainings/mytrainings/:tid/lessons/:id/contents/image" name="Contents" component={Contents} />
                <Route exact path="/trainings/mytrainings/:tid/lessons/:id/contents/document" name="Contents" component={Contents} />
                <Route exact path="/trainings/mytrainings/:tid/lessons/:id/contents" name="Contents" component={Contents} />
                <Route exact path="/trainings/mytrainings/:tid/lessons/:id/pictures" component={LessonPictures} />
                <Route exact path="/trainings/mytrainings/:tid/lessons/:id/notes" component={LessonNotes} />
                <Route exact path="/trainings/mytrainings/:tid/lessons/:id" name="Details" component={LessonDetails} />
                <Route exact path="/trainings/mytrainings/:id/lessons" name="Lessons" component={Lessons} />
                <Route exact path="/trainings/mytrainings/:id/results" name="Results" component={TrainingResults} />
                <Route exact path="/trainings/mytrainings/:id/start" name="Start Confirmation" component={StartConfirmation} />
                <Route exact path="/trainings/mytrainings/:id/finish" name="Finish Confirmation" component={EndConfirmation} />
                <Route exact path="/trainings/mytrainings/:id/pictures" component={TrainingPictures} />
                <Route exact path="/trainings/mytrainings/:id/notes" component={TrainingNotes} />
                <Route exact path="/trainings/mytrainings/:id/contents" name="ContentsTraining" component={ContentsTraining} />
                <Redirect from="/trainings/mytrainings/:id" to="/trainings/mytrainings/:id/lessons" />
                <Route exact path="/trainings/active" name="MyTrainings" render={(props) => <MyTrainings {...props} courses="active" />} />
                <Route exact path="/trainings/inactive" name="MyTrainings" render={(props) => <MyTrainings {...props} courses="inactive" />} />
                <Route exact path="/trainings/risk" name="MyTrainings" render={(props) => <MyTrainings {...props} courses="risk" />} />
                <Route exact path="/trainings/inspection" name="MyTrainings" render={(props) => <MyTrainings {...props} courses="inspection" />} />
                <Route exact path="/trainings/public" name="MyTrainings" render={(props) => <MyTrainings {...props} courses="public" />} />
                <Route exact path="/trainings/chats/:id" component={ChatDetails} />
                <Route exact path="/trainings/chats" component={Chats} />
                <Route exact path="/trainings/certificates" component={Certificates} />
                <Route exact path="/trainings/pictures" component={AllPictures} />
                <Route exact path="/trainings/notes" component={AllNotes} />
                <Route exact path="/trainings" name="MyTrainings" component={MyTrainings} />
                <Route exact path="/info/terms" component={InfoTerms} />
                <Route exact path="/info/service" component={InfoService} />
                <Route exact path="/info/faq" component={InfoFaq} />
                <Route exact path="/support" component={SupportChat} />
                <Route exact path="/change-password" name="ChangePassword" component={ChangePassword} />
                <Route exact path="/profile" name="Profile" component={Profile} />
                <Redirect from="/" to="/trainings" />
              </Switch>
            </Container>
            <div className="clear10" />
          </main>
        </div>
      </div>
    );
  }
}

Full.propTypes = {
  modal: PropTypes.objectOf(PropTypes.any),
  user: PropTypes.objectOf(PropTypes.any),
  hideModal: PropTypes.func,
  removeModal: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Full);



// WEBPACK FOOTER //
// ./src/containers/_Full/index.js